import ActionColumn from './ActionColumn.vue';
import LinkColumn from './LinkColumn.vue';

export default {
	ActionColumn,
	LinkColumn,
};
